import axiosClient from './base'

const VERIFY_PRACTICE_EXIST = '/api/practice/validate'

// TODO: practiceId shouldn't be null but it needs refactoing
export const updatePractice = async (
	practiceId: string | undefined,
	data: IPractice
): Promise<IPractice> => {
	const response = await axiosClient.put(`/api/practices/${practiceId}`, data)
	return response?.data?.practice
}

export const removePractice = (practiceId) => axiosClient.delete(`/api/practices/${practiceId}`)

export const getPractice = (practiceId) => axiosClient.get(`/api/practices/${practiceId}`)

export const listPracticeClients = ({ practiceId, name, pageNumber, pageSize, ...props }) =>
	axiosClient.get(`/api/practices/${practiceId}/clients`, {
		params: {
			name,
			pageNumber,
			pageSize,
			...props
		}
	})

export const getCommunicationHistory = ({
	practiceId,
	pageNumber,
	pageSize,
	endDate,
	startDate,
	search
}) =>
	axiosClient.get(`/api/practices/${practiceId}/communication-history`, {
		params: {
			pageNumber,
			pageSize,
			startDate,
			endDate,
			search
		}
	})

export const getPriorityCallList = ({
	practiceId,
	pageNumber,
	pageSize,
	reminderDueStartDate,
	reminderDueEndDate,
	reminderDescriptions
}) =>
	axiosClient.get(`/api/practices/${practiceId}/priority-call-list`, {
		params: {
			pageNumber,
			pageSize,
			reminderDueStartDate,
			reminderDueEndDate,
			reminderDescriptions
		}
	})

export const inviteUserToPractice = (params: InvitePracticeUser) =>
	axiosClient.post(`/api/practices/${params.practiceId}/invite-user`, params)

export const createStripeAccountSession = (practiceId: string) =>
	axiosClient.post(`/api/practices/${practiceId}/stripe_account_sessions`)

export const activatePracticeRequest = (practiceId: string) =>
	axiosClient.post(`/api/practices/${practiceId}/activate`)

export const createStripeVerificationSession = (practiceId: string) =>
	axiosClient.post(`/api/practices/${practiceId}/verification-sessions`)

export const verifyPracticeExists = ({ practiceWebsite, addressLine, zipCode, practiceName }) =>
	axiosClient.post(VERIFY_PRACTICE_EXIST, {
		practiceWebsite,
		addressLine,
		zipCode,
		practiceName
	})

export const createTerminalOrderIntent = (
	practiceId: string,
	payload: ICreateTerminalOrderIntentParams
) => axiosClient.post(`/api/practices/${practiceId}/terminal-order-intent`, payload)

export const addProductToPractice = (practiceId: string, product: 'payments' | 'lending') =>
	axiosClient.post(`/api/practices/${practiceId}/products/${product}`)
